import { Component, Output, EventEmitter, Input} from '@angular/core';
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ClientsService} from "../../models/clients/clients.service";
import {LeadsModel} from "../../models/leads/leads.model";
import {ClientStatusType} from "../../models/clients/clients.type";
import {AccountModalComponent} from "./account-modal/account-modal.component";


@Component({
    selector: 'client-status',
    templateUrl: 'client-status.template.html'
})
export class ClientStatusComponent {

    public leadStatuses: Array<any>;

    @Output() onAfterSave: EventEmitter<LeadsModel> = new EventEmitter<LeadsModel>();

    @Input() clientData;
    @Input() debtData;
    @Input() statuses;

    constructor(
        private toasterService: ToasterService,
        public clientsService: ClientsService,
        private modalService:NgbModal
    ) {

    }

    public changeStatus(statusElement) {
        let statusModel = {status: +statusElement.value, debtStatus: '', debtData: {}};
        if(statusModel.status == ClientStatusType.FUNDED) {
            const modalRef = this.modalService.open(AccountModalComponent);
            modalRef.componentInstance.client_id = this.clientData.id;
            modalRef.result
                .then((res) => {
                    if (res.hasOwnProperty('name')) {
                        statusModel.debtStatus = res.id;
                        statusModel.debtData = this.debtData;
                        this.saveClientStatus(statusModel, statusElement);
                    } else {
                        this.saveClientStatus({status: +statusElement.value, debt_id: res.id}, statusElement);
                    }
                }, (reason) => {
                    statusElement.value = "";
                });
            return;
        }
        this.saveClientStatus(statusModel, statusElement);
    }

    private saveClientStatus(statusModel, statusElement) {
        this.clientsService.setStatus(this.clientData.id, statusModel)
            .subscribe(res => {
                let message = res.data.message ? res.data.message : 'Status was changed';
                this.toasterService.pop('success', 'Success', message);
                this.onAfterSave.emit();
            }, (e) => {
                let errorData = JSON.parse(e._body);
                this.toasterService.pop('error', 'Error', errorData.message);
            });
        statusElement.value = '';
        return true;
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/client-status/client-status.component.ts